import * as types from './types'
import { IListSettings } from '@cbgms/api/modules/settings'

export const getSettings = (moduleName: string, type: string) => ({
  type: [types.GET_SETTINGS_LIST, types.GET_SETTINGS_LIST_SUCCESS, types.GET_SETTINGS_LIST_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/settings/global/list/${moduleName}/${type}`
    }
  }
})

export const setSettings = (moduleName: string, type: string, body: IListSettings) => ({
  type: [types.SET_SETTINGS_LIST, types.SET_SETTINGS_LIST_SUCCESS, types.SET_SETTINGS_LIST_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'POST',
      url: `/settings/global/list/${moduleName}/${type}`,
      data: body
    }
  }
})

export const removeSettings = (moduleName: string, type: string) => ({
  type: [types.REMOVE_SETTINGS_LIST, types.REMOVE_SETTINGS_LIST_SUCCESS, types.REMOVE_SETTINGS_LIST_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'DELETE',
      url: `/settings/global/list/${moduleName}/${type}`
    }
  }
})

export const supportGetSettings = (moduleName: string, type: string) => ({
  type: [types.SUPPORT_GET_SETTINGS_LIST, types.SUPPORT_GET_SETTINGS_LIST_SUCCESS, types.SUPPORT_GET_SETTINGS_LIST_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'GET',
      url: `/settings/global/list/${moduleName}/${type}`
    }
  }
})

export const supportSetSettings = (moduleName: string, type: string, body: IListSettings) => ({
  type: [types.SUPPORT_SET_SETTINGS_LIST, types.SUPPORT_SET_SETTINGS_LIST_SUCCESS, types.SUPPORT_SET_SETTINGS_LIST_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'POST',
      url: `/settings/global/list/${moduleName}/${type}`,
      data: body
    }
  }
})

export const supportRemoveSettings = (moduleName: string, type: string) => ({
  type: [types.SUPPORT_REMOVE_SETTINGS_LIST, types.SUPPORT_REMOVE_SETTINGS_LIST_SUCCESS, types.SUPPORT_REMOVE_SETTINGS_LIST_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'DELETE',
      url: `/settings/global/list/${moduleName}/${type}`
    }
  }
})
